module.exports = __webpack_public_path__ + "static/media/stars2.0d74dd46.svg";